import axios from './axiosService';

export default {
  initPermissions(team) {
    return {
      can_be_shared: team ? !!team.default_share_email : false,
      can_be_shared_link: team ? !!team.default_share_link : false,
      can_be_presented_by_user: team ? !!team.default_user_present_browser : false,
      can_be_annotated: team ? !!team.default_annotate : false,
      is_rateable: team ? !!team.default_rate_file : false,
      can_be_exported: team ? !!team.default_export_file : false,
      can_be_printed_by_user: team ? !!team.default_user_print_file : false,

      // Viewer
      can_be_downloaded: team ? !!team.default_download_file : false,
      can_be_printed: team ? !!team.default_print_file : false,
      can_be_forwarded: team ? !!team.default_forward_file : false,
    }
  },
  downloadDocument(connectionID, docID) {
    let link = document.createElement('a');
    link.href = `/proxy/veeva/vault/connections/${connectionID}/objects/documents/${docID}/file`;
    link.dispatchEvent(new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window}));
  },
  getConnections() {
    return axios.get(`/api/veeva/vault/connections`)
      .then(response => response.data)
  },
  retrieveDocuments(form = {}) {
    return axios.post(`/api/veeva/vault/documents`, form)
      .then(response => response.data);
  },
  async findDocumentByDocumentNumber(documentNumber, form = {}) {
    return axios.post(`/api/veeva/vault/documents/find/${documentNumber}`, form)
      .then(response => response.data);
  },
  retrieveDocument(connectionID, documentID, params = {}) {
    return axios.get(`/api/veeva/vault/connections/${connectionID}/document/${documentID}`, {params})
      .then(response => response.data);
  },
  retrieveProducts(params = {}) {
    return axios.get(`/api/veeva/vault/vobjects/product__v`, {params});
  },
  retrieveVaultObjects(objectName, params = {}) {
    console.log(objectName, params);
    return axios.get(`/api/veeva/vault/vobjects/${objectName}`, {params});
  },
  searchTasks(form = {}) {
    return axios.post(`/api/veeva/vault/tasks/search`, form)
      .then(response => response.data);
  },
  getTask(taskID) {
    return axios.get(`/api/veeva/vault/tasks/${taskID}`)
      .then(response => response.data);
  },
  deleteTask(taskID) {
    return axios.delete(`/api/veeva/vault/tasks/${taskID}`)
      .then(response => response.data);
  },
  runTask(taskID) {
    return axios.post(`/api/veeva/vault/tasks/${taskID}/start`)
      .then(response => response.data);
  },
  synchronizePresentation(presentationID) { // MLD-2493
    return axios.put(`/api/presentations/${presentationID}/vault/sync`)
      .then(response => response.data);
  }
}
